import type { TApiResp } from '@/types/api'
import type {
  TCryptoAddressListReq,
  TCryptoAddressListResp,
  TFlowListReq,
  TFlowListResp,
  TInviteListReq,
  TInviteListResp,
  TLoginReq,
  TLoginResp,
  TUserBalanceRecordReq,
  TUserBalanceRecordResp,
  TUserListReq,
  TUserListResp,
  TUserLoginHistoryReq,
  TUserLoginHistoryResp,
  TUserRechargeListReq,
  TUserRechargeListResp,
} from '@/types/api/user'
import api from '../index'

export default {
  // 登录（swagger basePath 为 /api/，完整路径为 /api/agent/base/login）
  login: (data: TLoginReq) =>
    api.post<TLoginReq, TApiResp<TLoginResp>>('api/base/login', data, {
      // baseURL: '/mock/',
      passError: true,
    }),

  // 获取权限
  permission: () => api.get('user/permission', {
    baseURL: '/mock/',
  }),

  // 修改密码
  passwordEdit: (data: {
    password: string
    newPassword: string
  }) => api.post('user/password/edit', data, {
    baseURL: '/mock/',
  }),

  // 用户列表
  userList: (data: TUserListReq) => api.post<TUserListReq, TApiResp<TUserListResp>>('api/user/userList', data),

  // 提现数字地址列表
  cryptoAddressList: (data: TCryptoAddressListReq) =>
    api.post<TCryptoAddressListReq, TApiResp<TCryptoAddressListResp>>('api/user/cryptoAddressList', data),

  // 账变列表
  flowList: (data: TFlowListReq) =>
    api.post<TFlowListReq, TApiResp<TFlowListResp>>('api/user/flowList', data),

  // 邀请码列表
  inviteList: (data: TInviteListReq) =>
    api.post<TInviteListReq, TApiResp<TInviteListResp>>('api/user/inviteList', data),

  // 用户充值地址列表
  rechargeAddressList: (data: TUserRechargeListReq) =>
    api.post<TUserRechargeListReq, TApiResp<TUserRechargeListResp>>('api/user/rechargeAddressList', data),

  // 后台资产操作记录(上下分/奖励赠送)
  userBalanceRecord: (data: TUserBalanceRecordReq) =>
    api.post<TUserBalanceRecordReq, TApiResp<TUserBalanceRecordResp>>('api/user/userBalanceRecord', data),

  // 登录历史
  userLoginHistory: (data: TUserLoginHistoryReq) =>
    api.post<TUserLoginHistoryReq, TApiResp<TUserLoginHistoryResp>>('api/user/userLoginHistory', data),
}
